import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getQuestionsByTopic,
} from "../services/api";
import "../style/Ques.css";
import api, { addResult } from "../services/api";

const Ques = ({ name }) => {
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const candidateId = localStorage.getItem("cid");

  // topic comes from state (for technical test), else aptitude
  const topic = location.state?.topic || null;

  useEffect(() => {
    const fetchData = async () => {
      try {
        let data;
        if (topic) {
          data = await getQuestionsByTopic(topic);
        } else {
          data = await getQuestionsByTopic("aptitude");
        }
        setQuestions(data.questions || []);
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    };
    fetchData();
  }, [topic]);

  const handleChange = (index, value) => {
    setAnswers({
      ...answers,
      [index]: value,
    });
  };

  // helper to normalize answer (supports a/b/c/d or 1/2/3/4 in DB)
  const normalize = (ans, options) => {
    if (!ans) return "";
    let val = String(ans).trim().toLowerCase();

    // if DB stores "1","2","3","4" → convert to a/b/c/d
    if (/^[1-4]$/.test(val)) {
      const idx = parseInt(val, 10) - 1;
      return String.fromCharCode(97 + idx); // → a,b,c,d
    }

    // if DB stores the actual text (like "Paris") → match with option
    const letters = ["a", "b", "c", "d"];
    for (let i = 0; i < options.length; i++) {
      if (val === String(options[i]).trim().toLowerCase()) {
        return letters[i];
      }
    }

    return val;
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // prevent page reload

    // Check if all questions have been answered
    if (Object.keys(answers).length !== questions.length) {
      alert("Please answer all questions before submitting.");
      return; // Stop the submission
    }

    let aptitudeScore = 0;
    let techScore = 0;

    for (let i = 0; i < questions.length; i++) {
      const q = questions[i];
      const selectedAnswer = answers[i] || null;

      // save in results API
      await addResult({
        cid: candidateId,
        q1: q.question,
        o1: q.o1 || q.options?.[0],
        o2: q.o2 || q.options?.[1],
        o3: q.o3 || q.options?.[2],
        o4: q.o4 || q.options?.[3],
        a1: q.ans,
        s1: selectedAnswer,
        test_name: topic || "aptitude",
      });

      // normalize both
      const correct = normalize(q.ans, [
        q.o1 || q.options?.[0],
        q.o2 || q.options?.[1],
        q.o3 || q.options?.[2],
        q.o4 || q.options?.[3],
      ]);
      const chosen = normalize(selectedAnswer, []);

      if (chosen && correct && chosen === correct) {
        if (!topic) aptitudeScore++;
        else techScore++;
      }
    }
 
    // update employee API
    if (topic) {
      await api.patch(`employees/${candidateId}/`, {
      // score: aptitudeScore,
      tech_score: techScore,
      topic: topic ,
    });
    } else {
      await api.patch(`employees/${candidateId}/`, {
      score: aptitudeScore,
      // tech_score: techScore,
      topic: "aptitude",
      count: 1,
    }
    );
    }

    if (topic) {
      navigate("/thankyou");
    } else {
      navigate("/index");
    }
  };

  return (
    <div className="ques-page">
      <h1 className="ques-page__title">{topic ? `${topic} Test` : `${name || "Aptitude"} Test`}</h1>

      <form onSubmit={handleSubmit} className="ques-page__form">
        {questions && questions.length > 0 ? (
          questions.map((item, index) => (
            <div key={index} className="ques-page__question-block">
              <div className="ques-page__question-text">
                <strong>Question {index + 1}:</strong> {item.question}
              </div>

              {["o1", "o2", "o3", "o4"].map((optKey, i) => {
                const optionLetter = String.fromCharCode(97 + i); // "a","b","c","d"
                return (
                  <label key={i} className="ques-page__option">
                    <input
                      type="radio"
                      name={`answer_${index}`}
                      value={optionLetter}
                      checked={answers[index] === optionLetter}
                      onChange={() => handleChange(index, optionLetter)}
                    />
                    {item[optKey]}
                  </label>
                );
              })}
            </div>
          ))
        ) : (
          <p className="ques-page__no-items">No questions found.</p>
        )}

        <div className="ques-page__submit-container">
          <input type="submit" value="Submit All Answers" className="ques-page__submit-btn" />
        </div>
      </form>
    </div>
  );
};

export default Ques;
